import { Badge } from "@/components/ui/badge"
import { Skeleton } from "@/components/ui/skeleton"

export type ContentTagsCellProps = {
  tags?: string[]
  max?: number
}

export function ContentTagsCell({ tags = [], max = 5 }: ContentTagsCellProps) {
  if (tags.length === 0) return null

  const visible = tags.slice(0, max)
  const overflow = tags.length - visible.length

  // Row of content-tag pills — wrap when the cell is narrow.
  return (
    <div className="flex flex-wrap">
      {visible.map((tag) => (
        <Badge key={tag} variant="secondary" className="mr-1 mb-1">
          {tag}
        </Badge>
      ))}
      {overflow > 0 ? (
        <Badge variant="outline" className="mb-1">
          +{overflow}
        </Badge>
      ) : null}
    </div>
  )
}

export function ContentTagsCellSkeleton() {
  return (
    <div className="flex flex-wrap">
      <Skeleton className="mr-1 mb-1 h-6 w-16 rounded-full" />
      <Skeleton className="mr-1 mb-1 h-6 w-20 rounded-full" />
      <Skeleton className="mb-1 h-6 w-14 rounded-full" />
    </div>
  )
}
